import axios from 'axios';
import { clearUserDetails } from 'src/redux-store/slices/userSlice';
import { persistor } from '../redux-store/appStore';

const API_BASE_URL = process.env.REACT_APP_API_URL;
export const SOCKET_URL = '';

// Utility to clear all local and session storage, and cookies
const clearTokens = () => {
  localStorage.clear();
  sessionStorage.clear();
  document.cookie =
    'Login_Success=false; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  persistor.purge();
};

// Redux state clearing function
const clearReduxState = (dispatch: any) => {
  dispatch(clearUserDetails());
};

// Function to logout the user (no hooks)
export const logoutUser = (dispatch: any, navigate: any) => {
  // Reset Redux state
  clearReduxState(dispatch);

  // Clear local/session storages and cookies
  clearTokens();

  // Redirect to login or home page using `navigate`
  navigate('/'); // Using the navigate function to redirect
};

// Function to handle token refresh
export const handleTokenRefresh = async (): Promise<string> => {
  try {
    const response = await axios.get(`${API_BASE_URL}/auth/refresh-token`, {
      withCredentials: true // Ensure cookies are sent with the request
    });
    const { accessToken } = response.data;
    return accessToken;
  } catch (error) {
    throw new Error('Unable to refresh token. Please log in again.');
  }
};
